import {
  WIDGET_JS_TEMPLATE,
  WIDGET_HTML_TEMPLATES,
  DEFAULT_WIDGET_CONFIGS,
} from './code-templates'

export const WIDGET_TYPES = {
  SIDEBAR: 'sidebar',
  MODAL: 'modal',
  DIRECT_LINK: 'direct-link',
  EMBED: 'embed',
}

export const INITIAL_WIDGET_OPTIONS = [
  {
    label: 'Sidebar Widget',
    widgetType: WIDGET_TYPES.SIDEBAR,
    description: 'Customize your sidebar widget settings.',
  },
  {
    label: 'Modal Widget',
    widgetType: WIDGET_TYPES.MODAL,
    description: 'Customize your modal widget settings.',
  },
  {
    label: 'Direct Link Widget',
    widgetType: WIDGET_TYPES.DIRECT_LINK,
    description: 'Set the direct link target.',
  },
  {
    label: 'Embed Widget',
    widgetType: WIDGET_TYPES.EMBED,
    description: 'Customize your embed widget settings.',
  },
]

export const WIDGET_COMPONENTS = {
  [WIDGET_TYPES.SIDEBAR]: 'SidebarWidget',
  [WIDGET_TYPES.MODAL]: 'ModalWidget',
  [WIDGET_TYPES.DIRECT_LINK]: 'DirectLinkWidget',
  [WIDGET_TYPES.EMBED]: 'EmbedWidget',
}

export { WIDGET_JS_TEMPLATE, WIDGET_HTML_TEMPLATES, DEFAULT_WIDGET_CONFIGS }
